export const uiStack = {
    name: 'UI Stack',
    description: '',
    displayField: 'title',
    fields: {
        title: {
            name: 'Title',
            type: 'Symbol',
            required: false,
            localized: false,
            disabled: false,
            omitted: false,
            validations: []
        },
        orientation: {
            name: 'Orientation',
            type: 'Symbol',
            required: true,
            localized: false,
            disabled: false,
            omitted: false,
            validations: [{ in: ['vertical', 'horizontal'] }]
        },
        spacing: {
            name: 'Spacing',
            type: 'Symbol',
            required: true,
            localized: false,
            disabled: false,
            omitted: false,
            validations: [
                {
                    in: ['none', 'tight', 'compact', 'cozy', 'comfortable', 'outerspace']
                }
            ]
        },
        fullHeight: {
            name: 'Full Height',
            type: 'Boolean',
            required: true,
            localized: false,
            disabled: false,
            omitted: false,
            validations: []
        },
        children: {
            name: 'Children',
            type: 'Array',
            required: false,
            localized: false,
            disabled: false,
            omitted: false,
            validations: [],
            items: {
                type: 'Link',
                validations: [{ linkContentType: ['uiBlock'] }],
                linkType: 'Entry'
            }
        }
    }
};
//# sourceMappingURL=uiStack.js.map